import { render, staticRenderFns } from "./OrderTags.vue?vue&type=template&id=74367d6c&scoped=true&"
import script from "./OrderTags.vue?vue&type=script&lang=js&"
export * from "./OrderTags.vue?vue&type=script&lang=js&"
import style0 from "./OrderTags.vue?vue&type=style&index=0&id=74367d6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74367d6c",
  null
  
)

export default component.exports